import toast from 'react-hot-toast';

function getErrorMessage(error: unknown, fallback: string) {
  if (error instanceof Error && error.message) return error.message;
  if (typeof error === 'string' && error.trim()) return error;
  return fallback;
}

function getApiErrorId(message: string) {
  const apiErrorMatch = message.match(/^API Error\s+(\d+)/i);
  if (apiErrorMatch) return `api-error-${apiErrorMatch[1]}`;

  if (/IP FORBIDDEN/i.test(message)) return 'api-error-ip-forbidden';
  return null;
}

export function showErrorToast(error: unknown, fallback: string, id?: string) {
  const message = getErrorMessage(error, fallback);
  const apiErrorId = getApiErrorId(message);
  const toastId = apiErrorId || id || undefined;

  toast.error(message, {
    id: toastId,
    duration: apiErrorId ? 8000 : 4000,
  });
}
